import { JetView } from 'webix-jet';

/**
 * FilterConcessionaireView class extends JetView to create a filter form.
 */
export default class FilterConcessionaireView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the form view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the form with user input
        const left = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'text',
                    name: 'AssociateUser', // Input field for associated user
                    label: _('Usuario Asociado'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Usuario Asociado'), // Placeholder text
                },
            ],
        };

        // Center left section of the form for concessionaire input
        const center_left = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'text',
                    name: 'Concessionaire', // Input field for concessionaire
                    label: _('Concesionario'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Concesionario'), // Placeholder text
                },
            ],
        };

        // Center right section of the form for subconcessionaire input
        const center_right = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'text',
                    name: 'Subconcessionaire', // Input field for subconcessionaire
                    label: _('Subconcesionario'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Subconcesionario'), // Placeholder text
                },
            ],
        };

        // Right section of the form, currently empty
        const right = {
            margin: 5,
            minWidth: 100,
            rows: [],
        };

        // Button section with actions for clearing and consulting
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('concessionaire:filter', [
                            filterdata, // Trigger filter event with form data
                        ]);
                    },
                },
            ],
        };

        // Upper section containing the input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right],
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            scroll: 'y', // Enable vertical scrolling
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form fields
            },
        };
    }
}

// FILE DOCUMENTED
